export default __webpack_public_path__ + "static/media/edificio_peq.17984277.png";